<template>
  <v-card class="fb-ad-card rounded-lg overflow-hidden" elevation="3">
    <!-- Header -->
    <div class="d-flex align-center px-4 pt-4 pb-2">
      <v-avatar size="40" style="border: 2px solid #74b0b9" class="me-3">
        <img src="https://i.pravatar.cc/100" alt="company" />
      </v-avatar>
      <div class="d-flex flex-column">
        <div class="d-flex align-center">
          <span class="font-weight-bold me-1">Company Name</span>
          <v-icon color="primary" size="16">mdi-check-decagram</v-icon>
        </div>
        <div class="text-caption text-grey d-flex align-center">
          1 min <span class="mx-1">·</span>
          <v-icon size="14">mdi-earth</v-icon>
        </div>
      </div>
    </div>
    <div class="pa-2">
      {{ post?.content || post?.caption }}
    </div>
    <div
      class="pa-2"
      v-if="post?.file?.file"
      style="max-height: 18rem; overflow: hidden"
    >
      <img
        class="media w-100"
        v-if="
          post?.file?.file &&
          post?.file?.file.type &&
          post?.file?.file.type.startsWith('image/')
        "
        :src="post?.file.preview"
        alt="Post Image"
      />
      <video
        v-if="
          post?.file?.file &&
          post?.file.file.type &&
          post?.file?.file.type.startsWith('video/')
        "
        width="100%"
        :src="post?.file?.preview"
        autoplay
        muted
        loop
      ></video>
    </div>
    <div v-else-if="post?.file?.preview">
      <img
        :src="post?.file?.preview"
        class="w-100"
        style="max-height: 16rem"
        alt=""
      />
    </div>
    <div class="pa-2" v-else>
      <img
        src="@/assets/images/noimg.png"
        class="w-100"
        style="max-height: 16rem"
        alt=""
      />
    </div>
    <!-- Actions -->
    <div class="d-flex justify-space-around align-center">
      <img src="@/assets/images/facebookbottom.png" class="w-100" alt="" />
    </div>
  </v-card>
</template>

<script>
import { publishPost } from "@/store/publishPost/publishPost.js";
// import { storeToRefs } from "pinia";

export default {
  name: "FacebookPostReview",
  data() {
    return {
      store: publishPost(),
      post: {},
    };
  },
  created() {
    const facebookPosts = this.store.post["facebook"];
    if (facebookPosts && facebookPosts.length > 0) {
      this.post = facebookPosts[0]; // أول بوست فقط
    }
  },
};
</script>

<style scoped>
.fb-ad-card {
  max-width: 420px;
  margin: auto;
  background-color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}
</style>
